export class Positional {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
}
